package com.essntl.features.message.domain.model

data class GroupParticipantModel(
    val id: String,
    val rank: String,
)
